import { generateUtilityClass, generateUtilityClasses, unstable_composeClasses } from "@mui/material";
const loginLayoutName = "TidalLoginLayout";
function getLoginLayoutUtilityClass(slot) {
  return generateUtilityClass(loginLayoutName, slot);
}
const loginLayoutClasses = generateUtilityClasses(loginLayoutName, [
  "root",
  "header",
  "footer",
  "content",
  "leftColumn",
  "rightColumn"
]);
function useUtilityClasses(ownerState) {
  const { classes } = ownerState;
  const slots = {
    root: ["root"],
    content: ["content"],
    header: ["header"],
    footer: ["footer"],
    leftColumn: ["leftColumn"],
    rightColumn: ["rightColumn"]
  };
  return unstable_composeClasses(slots, getLoginLayoutUtilityClass, classes);
}
export {
  getLoginLayoutUtilityClass,
  loginLayoutClasses,
  loginLayoutName,
  useUtilityClasses
};
//# sourceMappingURL=classes.js.map
